import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=1f2af563&scoped=true&"
import script from "./Withdrawal.vue?vue&type=script&lang=js&"
export * from "./Withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&id=1f2af563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2af563",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
